import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { getAppConfig } from './app/app.config';
import { WWWConfig } from './app/shared/models/config.model';

(async () => {
  let config: WWWConfig | undefined;

  // only get config with fetch if not SSR (ex: route is client-side)
  // when page is SSR, it is provided via TransferState
  if (!document.getElementById('ng-state')) {
    config = await fetch('/config.json').then((res) => res.json());
  }

  bootstrapApplication(AppComponent, getAppConfig(config)).catch((err) =>
    console.error(err)
  );
})();
